import type { JSX } from "react";

import { Menu as BaseMenu } from "@base-ui/react/menu";
import { useFloatingPortalContainer } from "@frontend/contexts";

import type { MenuPortalProps } from "./Menu.types";

export function MenuPortal({
  children,
  ...props
}: MenuPortalProps): JSX.Element {
  const container = useFloatingPortalContainer();

  return (
    <BaseMenu.Portal data-slot="menu-portal" container={container} {...props}>
      {children}
    </BaseMenu.Portal>
  );
}
